export default {
    meta: {
        title: '首页',
        url: '/home',
        urlName: '首页',
    }
};
